<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.administrative.task_manager.title')" header-tag="h3" class="bg-default-card">
                    <b-tabs>
                        <b-tab :title="$t('general.administrative.task_manager.open_tasks_title')" @click="refreshOpenTasks" class="removeFocus">
                            <openTasks ref="openTasks"></openTasks>
                        </b-tab>
                        <b-tab :title="$t('general.administrative.task_manager.closed_tasks_title') + ' / ' + $t('general.administrative.task_manager.archives_title')" @click="refreshClosedTasks" class="removeFocus">
                            <closedTasks ref="closedTasks"></closedTasks>
                        </b-tab>
                        <b-tab :title="$t('general.administrative.task_manager.sent_tasks_title')" @click="getAllSentTasks" class="removeFocus">
                            <sentTasks ref="sentTasks"></sentTasks>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import openTasks from '@/components/pages/project/administrative/task_manager/open_tasks.vue';
import closedTasks from '@/components/pages/project/administrative/task_manager/closed_tasks.vue';
import sentTasks from '@/components/pages/project/administrative/task_manager/sent_tasks.vue';

export default {
name: 'task_manager',
components: {
    openTasks,
    closedTasks,
    sentTasks
},
data () {
    return {
        breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.administrative.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.administrative.task_manager.title'),
                    active: true
                }
            ],
            currentTab: 0
        }
    },
    methods: {
        refreshOpenTasks () {
            if (this.currentTab != 0) {
                this.$refs.openTasks.loadTable();
            }
            this.currentTab = 0;
        },
        refreshClosedTasks () {
            if (this.currentTab != 1) {
                this.$refs.closedTasks.loadTable();
            }
            this.currentTab = 1;
        },
        getAllSentTasks () {
            if (this.currentTab != 2) {
                this.$refs.sentTasks.loadTable();
            }
            this.currentTab = 2;
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/project/administrative/task_manager/task_manager.vue